import type { User } from "firebase/auth";

export function googleProfileAvatar(value: string | null | undefined): string | undefined {
  if (!value || value.length > 2000) return undefined;
  try {
    const url = new URL(value);
    if (url.protocol !== "https:" || url.username || url.password || url.port) return undefined;
    if (!/^(?:[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\.)+googleusercontent\.com$/i.test(url.hostname)) return undefined;
    return url.toString();
  } catch {
    return undefined;
  }
}

export function defaultPlayerAvatar(user: Pick<User, "photoURL"> | null | undefined): string {
  return googleProfileAvatar(user?.photoURL) ?? "builtin:rocket";
}
